module.exports = __webpack_public_path__ + "img/bell.851b588d.png";